import React from 'react';
import {
  Button,
  FilterToolbar,
  FilterToolbarChips,
  FilterToolbarDivider,
  FilterToolbarSearch,
  ToolbarFilterMenu,
  type FilterToolbarChip,
  type MultiSelectOption,
} from '@chatsdet/ui';
import type { ExternalTestHealth, ExternalTestProvider } from '@chatsdet/types';

export function ExternalTestsCatalogFilterBar({
  searchInput,
  onSearchChange,
  suiteOptions,
  sourceOptions,
  providerOptions,
  healthOptions,
  suiteIds,
  sourceKeys,
  providers,
  health,
  chips,
  onChange,
  onClear,
  onRemove,
  attached,
}: {
  searchInput: string;
  onSearchChange: (value: string) => void;
  suiteOptions: MultiSelectOption[];
  sourceOptions: MultiSelectOption[];
  providerOptions: MultiSelectOption[];
  healthOptions: MultiSelectOption[];
  suiteIds?: string[];
  sourceKeys?: string[];
  providers?: ExternalTestProvider[];
  health?: ExternalTestHealth[];
  chips: FilterToolbarChip[];
  onChange: (updates: {
    suiteIds?: string[];
    sourceKeys?: string[];
    providers?: ExternalTestProvider[];
    health?: ExternalTestHealth[];
  }) => void;
  onClear: () => void;
  onRemove: (id: string) => void;
  /** Fuse with the table below (square bottom corners, no bottom border). */
  attached?: boolean;
}) {
  return (
    <FilterToolbar attached={attached}>
      <FilterToolbarSearch
        aria-label="Search external tests"
        placeholder="Search tests…"
        value={searchInput}
        onChange={onSearchChange}
      />
      <ToolbarFilterMenu
        label="Suite"
        options={suiteOptions}
        selectedIds={suiteIds ?? []}
        onChange={(ids) => onChange({ suiteIds: ids.length ? ids : undefined })}
      />
      <ToolbarFilterMenu
        label="Source"
        options={sourceOptions}
        selectedIds={sourceKeys ?? []}
        onChange={(ids) => onChange({ sourceKeys: ids.length ? ids : undefined })}
      />
      <ToolbarFilterMenu
        label="Provider"
        options={providerOptions}
        selectedIds={providers ?? []}
        onChange={(ids) => onChange({ providers: ids as ExternalTestProvider[] })}
        searchable={false}
      />
      <ToolbarFilterMenu
        label="Health"
        options={healthOptions}
        selectedIds={health ?? []}
        onChange={(ids) => onChange({ health: ids as ExternalTestHealth[] })}
        searchable={false}
      />
      <FilterToolbarDivider />
      {chips.length > 0 && (
        <Button variant="ghost" size="sm" className="text-muted-foreground" onPress={onClear}>
          Clear
        </Button>
      )}
      <FilterToolbarChips chips={chips} onRemove={onRemove} />
    </FilterToolbar>
  );
}
